import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

registerLocaleData(localeFr, "fr");

// Initialize Sentry before bootstrapping the app
if (environment.sentry.enabled) {
    Sentry.init({
        dsn: environment.sentry.dsn,
        environment: environment.sentry.environment,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        // Performance Monitoring
        tracesSampleRate: environment.production ? 0.1 : 1.0,
        // Session Replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        // Release tracking
        release: "nice-ops-dashboard@" + (environment.production ? "prod" : "dev")
    });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
